
import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  size?: number;
}

const animation1 = keyframes({
  '0%': {
    transform: 'translate(-1em, 4em)',
  },
  '100%': {
    transform: 'translate(0, 0)',
  },
});
const animation2 = keyframes({
  '0%': {
    transform: 'translate(0, 0)',
  },
  '100%': {
    transform: 'translate(1.2em, 0)',
  },
});
const animation3 = keyframes({
  '0%': {
    transform: 'translate(0, 0)',
  },
  '100%': {
    transform: 'translate(1em, 4em)',
  },
});

const useStyles = makeStyles()(theme => ({
  overlay: {
    top: theme.spacing(0),
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loaderWrapper: {
    fontSize: '12px !important',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loader: {
    width: '5.4em',
    height: '4em',
    display: 'inline-block',
    position: 'relative',
    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 30%, 0 100% )',
  },
  bar: {
    display: 'block',
    position: 'absolute',
    top: 0,
    width: '0.85em',
    height: '100%',
    borderRadius: '0.35em 0.35em 0 0',
    background: theme.customProperties.Legend.orange.full,
  },
  bar1: {
    left: '0.44em',
    animationName: `${animation1}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },

  bar2: {
    left: '0.44em',
    animationName: `${animation2}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },
  bar3: {
    left: '1.68em',
    animationName: `${animation2}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },
  bar4: {
    left: '2.92em',
    animationName: `${animation2}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },
  bar5: {
    left: '4.16em',
    animationName: `${animation3}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },
}));

/** Variant på AvenyProgress som är anpassad för att visas med rätt position i en EDDataGrid */
export const EDAvenyDataGridProgress = (props: IProps) => {
  const { classes, cx } = useStyles();
  const size: string = props.size ? props.size / 4 + 'px' : '12px';
  return (
    <div className={classes.loaderWrapper} style={{ fontSize: size }}>
      <div className={cx(classes.loader)}>
        <span className={cx(classes.bar, classes.bar1)}></span>
        <span className={cx(classes.bar, classes.bar2)}></span>
        <span className={cx(classes.bar, classes.bar3)}></span>
        <span className={cx(classes.bar, classes.bar4)}></span>
        <span className={cx(classes.bar, classes.bar5)}></span>
      </div>
    </div>
  );
};
